import { Star } from "lucide-react";

interface ReviewStarsProps {
  rating: number;
  size?: number;
  interactive?: boolean;
  onChange?: (rating: number) => void;
}

export const ReviewStars = ({ rating, size = 16, interactive = false, onChange }: ReviewStarsProps) => {
  return (
    <div className="flex gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          key={star}
          type={interactive ? "button" : undefined}
          disabled={!interactive}
          onClick={() => interactive && onChange?.(star)}
          className={interactive ? "cursor-pointer hover:scale-110 transition-transform" : "cursor-default"}
        >
          <Star
            size={size}
            className={
              star <= rating
                ? "fill-accent text-accent"
                : "fill-none text-muted-foreground/30"
            }
          />
        </button>
      ))}
    </div>
  );
};
